
// import 'lazysizes';
import Headroom from "headroom.js";
import imagesLoaded from 'imagesloaded';
import Flickity from 'flickity';
import 'flickity-fade';
import './plugins/jquery.fitvids';

// import 'slick-carousel';
import './modules/modal';
import './modules/aria-menu';
// import './modules/notification'

$(() => {

  const pageLoad = () => {

    // Carousels

    const siteheader = document.querySelector(".site-header");
    const headroom  = new Headroom(siteheader);
    headroom.init();


    document.querySelectorAll('.carousel').forEach((item) => {

        let settings = {
          pageDots: true,
          fade: true,
          wrapAround: true,
          autoPlay: true,
          pauseAutoPlayOnHover: false
        };

        // add fade mode
        if( "settings" in item.dataset ){
            settings = JSON.parse( item.dataset.settings );
        }

        const carousel = new Flickity( item, settings );
        const caption = item.parentNode.querySelector('.carousel-caption');
        // console.log(caption);

        carousel.on( 'change', function( index ) {
            caption.classList.add('is-changing');
        });

        carousel.on( 'settle', function( index ) {
            caption.classList.remove('is-changing');
            // caption.textContent = carousel.selectedElement.dataset.caption;
        });

    });

    // Sliders

    document.querySelectorAll('.slider').forEach((item) => {

      let settings = {
        pageDots: true,
        cellSelector: '.slider-item',
        groupCells: true,
        prevNextButtons: true
      };

      // add fade mode
      if( "settings" in item.dataset ){
          settings = JSON.parse( item.dataset.settings );
      }

      imagesLoaded( item, function( instance ) {
        // console.log('all images are loaded');
        const slider = new Flickity( item, settings );
      });

    });

    $('.video__player').fitVids();

    // Category drop downs

    $('.cat-drop').on('click', function(){
      $(this).parent().toggleClass('active');
      return false;
    });

    $('.category-filter, .archive-filter').on('mouseleave', function(){
      $(this).removeClass('active');
      return false;
    });

  }

  pageLoad();

});
